/** @format */

import { createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';
import { ENDPOINTS } from 'src/constants';

const initialState = {
  newsLoading: false,
  news: null,
  newsDetailLoading: false,
  newsDetail: null,
  newsArticlesLoading: null,
  newsArticles: null,
  categoriesLoading: false,
  categories: null,
  updateNewsLoading: false,
  ratingSuccess: false,
  ratingError: null,
  error: null
};

const slice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    //Get News Info
    getNews(state) {
      state.newsLoading = true;
    },
    getNewsSuccess(state, action) {
      const data = action.payload;
      state.news = data || [];
      state.newsLoading = false;
    },
    getNewsFailure(state, action) {
      state.error = action.payload;
      state.newsLoading = false;
    },
    //Get News Search
    getNewsArticles(state) {
      state.newsArticlesLoading = true;
    },
    getNewsArticlesSuccess(state, action) {
      const data = action.payload;
      state.newsArticles = data.articles || [];
      state.newsArticlesLoading = false;
    },
    getNewsArticlesFailure(state, action) {
      state.error = action.payload;
      state.newsArticlesLoading = false;
    },
    //Get News Categories
    getCategories(state) {
      state.categoriesLoading = true;
    },
    getCategoriesSuccess(state, action) {
      const data = action.payload;
      state.categories = data.categories || [];
      state.categoriesLoading = false;
    },
    getCategoriesFailure(state, action) {
      state.error = action.payload;
      state.categoriesLoading = false;
    },
    getNewsDetail(state) {
      state.newsDetailLoading = true;
    },

    getNewsDetailSuccess(state, action) {
      const data = action.payload;
      state.newsDetailLoading = false;
      state.newsDetail = data;
    },
    getNewsDetailFailure(state, action) {
      state.error = action.payload;
      state.newsDetailLoading = false;
    },
    rateArticle(state) {
      state.newsDetailLoading = true;
    },
    rateArticleSuccess(state) {
      state.ratingSuccess = true;
      state.newsDetailLoading = false;
    },
    rateArticleFailure(state, action) {
      state.newsDetailLoading = false;
      state.ratingError = action.payload.error;
    },
    clearNewstError(state, action) {
      state.error = null;
      state.ratingError = null;
      state.ratingSuccess = false;
    },
    resetNewsError(state, action) {
      state.error = action.payload;
      state.newsLoading = false;
    },
    setNewsTitle(state, action) {
      state.newsDetail = { ...state.newsDetail, title: action.payload };
    }
  }
});

export const reducer = slice.reducer;

// News Search
export const getNewsArticles = params => async dispatch => {
  const { getNewsArticles, getNewsArticlesSuccess, getNewsFailure } = slice.actions;

  try {
    dispatch(getNewsArticles());
    const response = await axios.get(`${ENDPOINTS.GET_NEWS_ENDPOINT}/search/`, {
      params: params
    });
    dispatch(getNewsArticlesSuccess(response.data));
  } catch (err) {
    dispatch(getNewsFailure(err));
  }
};

// News Categories
export const getNewsCategories = () => async dispatch => {
  const { getCategories, getCategoriesSuccess, getCategoriesFailure } = slice.actions;

  try {
    dispatch(getCategories());
    const response = await axios.get(`${ENDPOINTS.GET_NEWS_CATEGORIES_ENDPOINT}`);
    dispatch(getCategoriesSuccess(response.data));
  } catch (err) {
    dispatch(getCategoriesFailure(err));
  }
};

export const getNewsDetail = (id, noLoad) => async dispatch => {
  const { getNewsDetail, getNewsDetailSuccess, getNewsDetailFailure } = slice.actions;
  try {
    if (!noLoad) dispatch(getNewsDetail());
    const response = await axios.get(`${ENDPOINTS.GET_NEWS_ENDPOINT}/${id}`);
    dispatch(getNewsDetailSuccess(response.data));
  } catch (err) {
    dispatch(getNewsDetailFailure(err));
  }
};

export const rateNewsDetail = (nid, rating) => async dispatch => {
  const { rateArticleSuccess, rateArticleFailure } = slice.actions;
  try {
    const formData = new FormData();
    formData.append('newsArticle', nid);
    formData.append('rating', rating);
    await axios.post(ENDPOINTS.GET_NEWS_VOTE_ENDPOINT, formData);
    dispatch(rateArticleSuccess());
    dispatch(getNewsDetail(nid, true));
  } catch (err) {
    dispatch(rateArticleFailure(err));
  }
};
export const clearNewstError = () => dispatch => {
  const { clearNewstError } = slice.actions;
  dispatch(clearNewstError());
};
export const resetNewsError = () => async dispatch => {
  const { resetNewsError } = slice.actions;
  dispatch(resetNewsError(null));
};

export const setNewsTitle = title => async dispatch => {
  const { setNewsTitle } = slice.actions;
  dispatch(setNewsTitle(title));
};

export default slice;
